import { GlobalStyle } from "./styles/global";
import { Header } from "./components/Header/Header";
import { Dashboard } from "./components/Dashboard/Dashboard";
import { Footer } from "./components/Footer/Footer";

export function App() {
  return (
    <>
      <GlobalStyle />
      <Header />
      <Dashboard /> 
      <Footer />
    </>
  );
}


